export enum EmpresaErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  NOT_FOUND = "NOT_FOUND",
  FORBIDDEN = "FORBIDDEN",
  INVALID_DATA = "INVALID_DATA",
  DUPLICATE = "DUPLICATE",
}

export class EmpresaDomainError extends Error {
  code: EmpresaErrorCode;
  status: number;

  constructor(message: string, code: EmpresaErrorCode, status = 400) {
    super(message);
    this.name = "EmpresaDomainError";
    this.code = code;
    this.status = status;
  }
}
